module.exports = __webpack_public_path__ + "static/media/display_green.28701240.png";